import { FC } from 'react';
import styled, { css } from 'styled-components';
import { nameof } from '../../utils/stringUtils';
import { IconProps } from './LayeredIcons';
import CardContainer from '../teams/CardContainer';
import { ExtrasButton } from './ExtrasButton';
import KpiDisplay, { ICardItemProps } from './KpiDisplay';
import { CardHeader, Title } from './StyledComponents';

const StyledCardContainer = styled(CardContainer)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  overflow-x: auto;
`;

const KpiDisplayContainer = styled.div<{ showSeparator: boolean }>`
  flex-grow: 1;

  display: grid;
  grid-auto-flow: row;
  grid-auto-columns: 1fr;
  grid-template-rows: 1fr;

  > * {
    grid-row: 1;
    padding: 0 0.5rem;
  }

  ${p => p.showSeparator && css`
    > :not(:last-child) {
      border-right: 1px solid ${p.theme.palette.neutralQuaternary};
    }
  `}
`;

interface IProps {
    gridArea?: string;
    showSeparator?: boolean;
    title?: string;
    onExtrasButtonClick?(): void;
    extrasButtonIcon?: string | IconProps[];
    extrasButtonTooltip?: string;
    items: ICardItemProps | ICardItemProps[];
    minHeight?: string | number;
}

const Card: FC<IProps> = ({ gridArea, showSeparator, title, onExtrasButtonClick, extrasButtonIcon, extrasButtonTooltip, items, minHeight }) => (
    <StyledCardContainer gridArea={gridArea} data-area={gridArea} minHeight={minHeight}>
        {
            title &&
            <CardHeader>
                <Title>{title}</Title>
                {
                    onExtrasButtonClick &&
                    <ExtrasButton onClick={onExtrasButtonClick} icon={extrasButtonIcon} tooltip={extrasButtonTooltip} />
                }
            </CardHeader>
        }
        {
            Array.isArray(items)
                ? (
                    <KpiDisplayContainer showSeparator={!!showSeparator}>
                        {items.map((itemProps, i) => <KpiDisplay key={i} {...itemProps} />)}
                    </KpiDisplayContainer>
                )
                : <KpiDisplay {...items} />
        }
    </StyledCardContainer>
);

Card.displayName = nameof({ Card });
export default Card;